"use client";

import { Namespace } from "@/src/i18n/namespace";
import { useTranslations } from "next-intl";
import { InternalErrorPageLayout } from "./InternalErrorPageLayout";
export function InternalErrorPage() {
  const tCommon = useTranslations(Namespace.COMMON);
  return <InternalErrorPageLayout title={tCommon("errorScreens.internalError.title")} description={tCommon("errorScreens.internalError.description")} data-sentry-element="InternalErrorPageLayout" data-sentry-component="InternalErrorPage" data-sentry-source-file="InternalErrorPage.tsx" />;
}